/*
 * Northern Legends — legend-motion.js
 * Fælles scroll/motion-engine for legend-siderne. Bygget på prototypernes legend-engine.js
 * og udvidet med Jacob Banks (tv, tidslinje, EKG, bælter) og Alex Maansens (startlys,
 * speedometer, hårnålesving, ternet flag) signaturscener.
 *
 * Markup bruger data-attributter (se README). Konfiguration læses fra
 * <script type="application/json" data-legend-config> i legend-story-sektionen.
 * Ingen afhængigheder.
 */
(function () {
  if (window.LegendEngine) return;

  var clamp = function (v, a, b) { if (a === undefined) a = 0; if (b === undefined) b = 1; return Math.max(a, Math.min(b, v)); };
  var ease = function (t) { return 1 - Math.pow(1 - t, 3); };
  var win = function (p, a, b, f) { f = f || 0.06; return clamp((p - a) / f) * (1 - clamp((p - b) / f)); };
  var EASE = 'cubic-bezier(.2,.7,0,1)';
  var GRAIN = "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='180' height='180'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='2' stitchTiles='stitch'/></filter><rect width='100%25' height='100%25' filter='url(%23n)'/></svg>\")";
  var pair = function (s) { return String(s).split(',').map(Number); };
  var pad2 = function (n) { return String(n).padStart(2, '0'); };
  var mmss = function (t) { return Math.floor(t / 60) + ':' + pad2(t % 60); };

  /* ---------- Scorebug (HUD) pr. legend ---------- */
  var HUDS = {
    jacob: function (s) { var secs = Math.round(180 * (1 - s.local)); return { clock: mmss(secs) }; },
    alex: function (s) { var ms = s.lapMs, m = Math.floor(ms / 60000), x = Math.floor(ms / 1000) % 60, f = Math.floor(ms % 1000); return { clock: m + ':' + pad2(x) + '.' + String(f).padStart(3, '0') }; },
    jonny: function (s) { return { label: 'Højde', value: ((1 - s.overall) * 10).toFixed(1).replace('.', ',') + ' m' }; },
    martin: function (s) { return { label: 'Puls', value: Math.round(Math.min(190, 62 + s.v / 14)) + ' bpm' }; },
    mikkel: function (s) { var t = Math.floor(s.ms / 1000); return { label: 'Din tid her', value: mmss(t) }; },
    oliver: function (s) { return { label: 'Dønning', value: (0.4 + Math.min(3.6, s.v / 700)).toFixed(1).replace('.', ',') + ' m' }; },
    stefan: function (s) { return { label: 'Skudur', value: String(Math.max(0, Math.ceil(24 * (1 - s.local)))) }; },
    sven: function (s) { return { label: 'Næste stop', value: ['Route 66', 'Grand Canyon', 'Korsika', 'Franske alper', 'Nye horisonter'][s.active] || '' }; },
    victor: function (s) {
      var m = s.active < 2 ? (s.active + s.local) / 2 * 30 : s.active === 2 ? 30 : 30 + (s.active - 3 + s.local) / 2 * 30;
      var t = Math.floor(m * 60);
      return { label: s.active < 2 ? '1. halvleg' : s.active === 2 ? 'Pause' : '2. halvleg', value: pad2(Math.floor(t / 60)) + ':' + pad2(t % 60) };
    }
  };

  /* ---------- Variant-parametre (fra prototyperne) ---------- */
  var VARIANTS = {
    std: { heroEnd: 0.6, knockFade: 0.45, knockFadeCalm: 0.25, afterStart: 0.55, afterAxis: 'y', introUp: 300, intro: 900, introStep: 110, stampRot: -8, countDur: 1400, countDownLinear: 0, bulbs: 'std' },
    jacob: { heroEnd: 0.62, knockFade: 0.5, knockFadeCalm: 0.3, afterStart: 0.6, afterAxis: 'y', introUp: 350, intro: 900, introStep: 120, stampRot: -12, countDur: 1300, countDownLinear: 2000, bulbs: 'jacob' },
    alex: { heroEnd: 0.6, knockFade: 0.42, knockFadeCalm: 0.25, afterStart: 0.52, afterAxis: 'x', introUp: 300, intro: 900, introStep: 110, stampRot: -6, countDur: 1300, countDownLinear: 0, bulbs: 'std' }
  };

  function readConfig() {
    var el = document.querySelector('script[data-legend-config]');
    if (!el) return {};
    try { return JSON.parse(el.textContent) || {}; } catch (e) { return {}; }
  }

  function mount(root, opts) {
    opts = opts || {};
    var V = Object.assign({}, VARIANTS.std, VARIANTS[opts.variant] || {});
    var E = { anims: [], timers: [], v: 0, lastY: 0, lastT: 0, lapIdx: -1, lapStart: performance.now(), t0: performance.now(), alive: true, st: null, listeners: [] };
    var calm = function () { return !!opts.calm || window.matchMedia('(prefers-reduced-motion: reduce)').matches; };
    var $ = function (s, el) { return (el || root).querySelector(s); };
    var $$ = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };
    var on = function (t, ev, fn, o) { t.addEventListener(ev, fn, o); E.listeners.push([t, ev, fn, o]); };
    var loop = function (el, kf, o) { if (el.animate) E.anims.push(el.animate(kf, Object.assign({ iterations: Infinity }, o))); };
    var anim = function (el, kf, o) { if (el.animate) return el.animate(kf, o); };
    var hud = HUDS[opts.hud] || null;
    var accent = function () { return getComputedStyle(root).getPropertyValue('--acc').trim() || '#e2b64c'; };
    var C = calm();
    if (C) root.classList.add('nl-calm');

    var grain = document.createElement('div');
    grain.setAttribute('aria-hidden', 'true');
    grain.style.cssText = 'position:fixed;inset:0;pointer-events:none;z-index:100;opacity:0.05;background-image:' + GRAIN;
    document.body.appendChild(grain);

    $$('img[data-src]').forEach(function (i) { var s = i.dataset.src; if (s && i.getAttribute('src') !== s) i.setAttribute('src', s); });

    /* ---------- Intro + uendelige loops ---------- */
    if (!C) {
      $$('[data-intro],[data-intro-up]').forEach(function (el, i) {
        var up = el.hasAttribute('data-intro-up');
        anim(el, up ? [{ transform: 'translateY(110%)' }, { transform: 'none' }] : [{ opacity: 0, transform: 'translateY(12px)' }, { opacity: 1, transform: 'none' }],
          { duration: up ? 1100 : 700, delay: up ? V.introUp + i * 140 : V.intro + i * V.introStep, easing: EASE, fill: 'backwards' });
      });
      var bulbs = $('[data-bulbs]');
      if (bulbs) {
        if (V.bulbs === 'jacob') anim(bulbs, [{ opacity: 0 }, { opacity: 0.85, offset: 0.04 }, { opacity: 0, offset: 0.12 }, { opacity: 0, offset: 0.3 }, { opacity: 0.6, offset: 0.33 }, { opacity: 0, offset: 0.42 }, { opacity: 0.9, offset: 0.46 }, { opacity: 0, offset: 0.6 }, { opacity: 0 }], { duration: 1800, delay: 1200 });
        else anim(bulbs, [{ opacity: 0 }, { opacity: 0.8, offset: 0.05 }, { opacity: 0, offset: 0.15 }, { opacity: 0, offset: 0.35 }, { opacity: 0.6, offset: 0.4 }, { opacity: 0 }], { duration: 1600, delay: 1100 });
      }
      /* Alex: startlys → LIGHTS OUT → navnet suser ind */
      var lights = $$('[data-light]');
      if (lights.length) {
        var step = 420, t0 = 500, out = t0 + lights.length * step + 700;
        lights.forEach(function (l, i) {
          anim(l, [{ background: '#e23a2a', boxShadow: '0 0 24px #e23a2a', offset: 0 }, { background: '#e23a2a', boxShadow: '0 0 24px #e23a2a', offset: 0.99 }, { background: '#2a2622', boxShadow: 'none', offset: 1 }],
            { duration: out - (t0 + i * step), delay: t0 + i * step, fill: 'none' });
        });
        var lo = $('[data-lightsout]');
        if (lo) anim(lo, [{ opacity: 0, transform: 'translateY(-50%) scale(1.4)' }, { opacity: 1, transform: 'translateY(-50%) scale(1)', offset: 0.15 }, { opacity: 1, offset: 0.6 }, { opacity: 0, transform: 'translateY(-50%) scale(0.96)' }], { duration: 1100, delay: out });
        $$('[data-rush]').forEach(function (el, i) {
          anim(el, [{ transform: 'translateX(70vw) skewX(-24deg)', filter: 'blur(14px)', opacity: 0 }, { opacity: 1, offset: 0.2 }, { transform: 'none', filter: 'blur(0)', opacity: 1 }], { duration: 900, delay: out + 250 + i * 160, easing: EASE, fill: 'backwards' });
        });
      }
      $$('[data-marquee]').forEach(function (m) {
        var d = m.dataset.dir === '-1';
        loop(m, d ? [{ transform: 'translateX(-50%)' }, { transform: 'none' }] : [{ transform: 'none' }, { transform: 'translateX(-50%)' }], { duration: +(m.dataset.speed || 30000) });
      });
      $$('[data-pulse]').forEach(function (s) { loop(s, [{ opacity: 0.2 }, { opacity: 0.9, offset: 0.1 }, { opacity: 0.35, offset: 0.2 }, { opacity: 1, offset: 0.3 }, { opacity: 0.2, offset: 0.6 }, { opacity: 0.2 }], { duration: 1300 }); });
      $$('[data-spin]').forEach(function (s) {
        var y = s.dataset.spinAxis === 'y';
        loop(s, [{ transform: y ? 'rotateY(0deg)' : 'rotate(0deg)' }, { transform: y ? 'rotateY(360deg)' : 'rotate(360deg)' }], { duration: +(s.dataset.spin || 12000) });
      });
      $$('[data-bob]').forEach(function (s, i) { loop(s, [{ transform: 'translateY(-8px)' }, { transform: 'translateY(8px)' }, { transform: 'translateY(-8px)' }], { duration: 1800, delay: -i * 160, easing: 'ease-in-out' }); });
      $$('[data-static]').forEach(function (s) { loop(s, [{ transform: 'translate(0,0)' }, { transform: 'translate(-20px,14px)' }, { transform: 'translate(12px,-22px)' }, { transform: 'translate(-8px,-6px)' }, { transform: 'translate(18px,10px)' }], { duration: 400, easing: 'steps(5)' }); });
      $$('[data-checker]').forEach(function (c) { loop(c, [{ backgroundPosition: '0 0' }, { backgroundPosition: '80px 0' }], { duration: 1600 }); });
      $$('[data-flag-cell]').forEach(function (c) { var col = +c.dataset.col; loop(c, [{ transform: 'translateY(-5px)' }, { transform: 'translateY(5px)' }, { transform: 'translateY(-5px)' }], { duration: 1400, delay: -col * 90, easing: 'ease-in-out' }); });
      $$('[data-slides]').forEach(function (box) {
        var slides = $$(':scope > img', box);
        if (slides.length < 2) return;
        var k = 0;
        E.timers.push(setInterval(function () { slides[k].style.opacity = '0'; k = (k + 1) % slides.length; slides[k].style.opacity = '1'; }, 2600));
      });
    }

    /* ---------- Tællere ---------- */
    function countUp(el) {
      var to = parseFloat(el.dataset.count), from = parseFloat(el.dataset.from || '0');
      if (isNaN(to) || el.dataset.counted) return;
      el.dataset.counted = '1';
      if (calm()) { el.textContent = String(to); return; }
      var down = to < from && V.countDownLinear;
      var t0 = performance.now(), dur = down ? V.countDownLinear : V.countDur;
      var st = function (now) {
        var t = clamp((now - t0) / dur);
        el.textContent = String(Math.round(from + (to - from) * (down ? t : ease(t))));
        if (t < 1) requestAnimationFrame(st);
      };
      requestAnimationFrame(st);
    }

    /* ---------- Reveal ved scroll ---------- */
    var rot = V.stampRot;
    var FROM = { up: 'translateY(56px)', left: 'translateX(-18vw)', right: 'translateX(18vw)', zoom: 'scale(.6)', stamp: 'rotate(' + rot + 'deg) scale(3)', drop: 'translateY(-50vh)' };
    var TO = { stamp: 'rotate(' + rot + 'deg) scale(1)' };
    E.io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target; E.io.unobserve(el);
        var kind = el.dataset.reveal || 'up', d = +(el.dataset.delay || 0);
        if (kind === 'vanish') {
          if (calm()) el.style.opacity = '0.1';
          else anim(el, [{ opacity: 1, filter: 'none' }, { opacity: 0.1, filter: 'blur(3px)' }], { duration: 700, delay: 700 + d, fill: 'forwards' });
          return;
        }
        el.style.opacity = '';
        if (!calm()) anim(el, [{ opacity: 0, transform: FROM[kind] || FROM.up }, { opacity: 1, transform: TO[kind] || 'none' }],
          { duration: kind === 'stamp' ? 380 : kind === 'zoom' ? 700 : 1000, delay: d,
            easing: kind === 'zoom' ? 'cubic-bezier(.3,1.5,.5,1)' : kind === 'stamp' ? 'cubic-bezier(.6,0,.9,.4)' : kind === 'drop' ? 'cubic-bezier(.5,0,.2,1.3)' : EASE, fill: 'backwards' });
        [el].concat($$('[data-count]', el)).forEach(function (c) { if (c.dataset.count != null) countUp(c); });
        $$('[data-bar]', el).forEach(function (b) {
          var v = parseFloat(b.dataset.bar || '0');
          b.style.transform = 'scaleX(' + v + ')';
          if (!calm()) anim(b, [{ transform: 'scaleX(0)' }, { transform: 'scaleX(' + v + ')' }], { duration: 1200, delay: 300, easing: EASE, fill: 'backwards' });
        });
        if (!calm()) $$('[data-sector]', el).forEach(function (s) {
          anim(s, [{ filter: 'brightness(3)', transform: 'scaleX(0)' }, { filter: 'brightness(1)', transform: 'scaleX(1)' }], { duration: 500, delay: 300 + +(s.dataset.delay || 0), easing: EASE, fill: 'backwards' });
        });
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -6% 0px' });
    $$('[data-reveal]').forEach(function (el) { if (el.dataset.reveal !== 'vanish') el.style.opacity = '0'; E.io.observe(el); });

    /* ---------- "Mød de andre": foto følger cursoren ---------- */
    var list = $('[data-cursor-list]'), fl = $('[data-float]'), fimg = $('[data-float-img]');
    if (list && fl && fimg) {
      on(list, 'mousemove', function (e) {
        var row = e.target.closest('[data-thumb]');
        if (!row) { fl.style.opacity = '0'; return; }
        if (fimg.getAttribute('src') !== row.dataset.thumb) fimg.setAttribute('src', row.dataset.thumb);
        fl.style.opacity = '1';
        fl.style.transform = 'translate(' + (e.clientX + 24) + 'px, ' + (e.clientY - fl.offsetHeight / 2) + 'px) rotate(' + (calm() ? 0 : (e.movementX || 0) * 0.4) + 'deg)';
      });
      on(list, 'mouseleave', function () { fl.style.opacity = '0'; });
    }

    /* ---------- Shake ved landing af rundetal ---------- */
    function shake(el) {
      var stage = $('[data-card-stage]', el), flash = $('[data-card-flash]', el);
      if (el.dataset.cardStyle === 'race') anim(stage, [{ transform: 'none' }, { transform: 'translateX(-22px) skewX(-4deg)' }, { transform: 'translateX(14px)' }, { transform: 'translateX(-6px)' }, { transform: 'none' }], { duration: 420, easing: 'ease-out' });
      else anim(stage, [{ transform: 'none' }, { transform: 'translate(-16px,10px)' }, { transform: 'translate(14px,-12px)' }, { transform: 'translate(-9px,7px)' }, { transform: 'translate(5px,-3px)' }, { transform: 'none' }], { duration: 450, easing: 'ease-out' });
      if (flash) anim(flash, [{ opacity: V.bulbs === 'jacob' ? 0.85 : 0.8 }, { opacity: 0 }], { duration: el.dataset.cardStyle === 'race' ? 500 : 550, easing: 'ease-out' });
    }

    /* ---------- Sticky "pins": p = progress 0–1 ---------- */
    /* Skriv kun en style, hvis værdien faktisk er ændret (færre repaints) */
    var S = function (el, prop, v) { var c = el.__nls || (el.__nls = {}); if (c[prop] !== v) { c[prop] = v; el.style[prop] = v; } };
    var Q = {};
    var q = function (sel) { return Q[sel] || (Q[sel] = $$(sel)); };
    var q1 = function (sel) { if (!(sel in Q)) Q[sel] = $(sel); return Q[sel]; };

    var PINS = {
      hero: function (el, p, c) {
        var k = $('[data-knock]', el), ui = $('[data-hero-ui]', el), af = $('[data-hero-after]', el);
        if (!k) return;
        var m = el.dataset.mode || 'zoom', z = c.calm ? 0 : clamp(p / V.heroEnd);
        if (m === 'zoom') {
          var o = $('[data-origin]', el);
          if (!E.origin && o) {
            S(k, 'transform', 'none');
            var kr = k.getBoundingClientRect(), or = o.getBoundingClientRect();
            E.origin = (or.left - kr.left + or.width * 0.2) + 'px ' + (or.top - kr.top + or.height * 0.55) + 'px';
            S(k, 'transformOrigin', E.origin);
          }
          S(k, 'transform', 'scale(' + Math.min(40, 1 + Math.pow(z, 3.2) * 70).toFixed(3) + ')');
        } else if (m === 'rush') {
          var e = ease(z); S(k, 'transform', 'translateX(' + (-e * 130) + '%) skewX(' + (-e * 28) + 'deg)'); S(k, 'filter', c.calm ? '' : 'blur(' + (e * 10) + 'px)');
          var lines = $('[data-speedlines]', el);
          if (lines) lines.dataset.base = String(c.calm ? 0 : Math.sin(clamp(p / V.heroEnd) * Math.PI) * 0.9);
        } else if (m === 'drop') {
          S(k, 'transform', 'translateY(' + (z * z * 130) + 'vh) rotate(' + (z * z * 16) + 'deg)');
        } else if (m === 'split') {
          var e2 = ease(z); $$('[data-line]', k).forEach(function (l, i) { S(l, 'transform', 'translateX(' + ((i % 2 ? 1 : -1) * e2 * 110) + 'vw)'); });
        }
        var ko = 1 - clamp((p - (c.calm ? V.knockFadeCalm : V.knockFade)) / 0.14);
        S(k, 'opacity', String(ko)); S(k, 'visibility', ko <= 0.001 ? 'hidden' : 'visible');
        if (ui) { var uo = 1 - clamp(p * 5); S(ui, 'opacity', String(uo)); S(ui, 'visibility', uo <= 0.001 ? 'hidden' : 'visible'); }
        if (af) {
          var a = clamp((p - V.afterStart) / 0.16);
          S(af, 'opacity', String(a)); S(af, 'visibility', a <= 0.001 ? 'hidden' : 'visible');
          S(af, 'transform', V.afterAxis === 'x' ? 'translateX(' + ((1 - ease(a)) * 80) + 'px)' : 'translateY(' + ((1 - ease(a)) * 60) + 'px)');
          S(af, 'pointerEvents', a > 0.5 ? 'auto' : 'none');
        }
      },
      statement: function (el, p, c) {
        var steps = $$('[data-step]', el), n = steps.length;
        steps.forEach(function (s, i) { var k = c.calm ? 1 : clamp(p * (n + 0.8) - i); S(s, 'opacity', String(0.1 + 0.9 * k)); S(s, 'filter', c.calm || k >= 1 ? 'none' : 'blur(' + (Math.round((1 - k) * 12) / 2) + 'px)'); });
      },
      ecg: function (el, p, c) {
        PINS.statement(el, clamp((p - 0.15) / 0.8), c);
        var line = $('[data-ecg]', el);
        if (line) line.setAttribute('stroke-dashoffset', String(c.calm ? 0 : 1 - clamp(p * 1.4)));
      },
      card: function (el, p, c) {
        var num = $('[data-card-num]', el), fill = $('[data-card-fill]', el), title = $('[data-card-title]', el);
        if (!num) return;
        var race = el.dataset.cardStyle === 'race';
        var land = c.calm ? 1 : clamp(p / 0.32);
        S(num, 'transform', race ? 'translateX(' + (Math.pow(1 - land, 2) * 90) + 'vw) skewX(' + (-(1 - land) * 30) + 'deg)' : 'scale(' + (1 + 1.6 * Math.pow(1 - land, 2)) + ')');
        S(num, 'opacity', String(land));
        var f = c.calm ? 1 : clamp((p - 0.32) / 0.5);
        if (fill) S(fill, 'clipPath', race ? 'inset(0 ' + ((1 - f) * 100) + '% 0 0)' : 'inset(' + ((1 - f) * 100) + '% 0 0 0)');
        var t = c.calm ? 1 : ease(clamp((p - 0.3) / 0.25));
        if (title) { S(title, 'transform', 'translateX(' + ((1 - t) * (race ? 120 : -80)) + 'px)'); S(title, 'opacity', String(t)); }
        if (!c.calm && land >= 1 && !el.dataset.landed) { el.dataset.landed = '1'; if (E.dir > 0) shake(el); }
        if (land < 0.5) delete el.dataset.landed;
      },
      /* Jacob: gammelt TV der zoomer til fuldskærm */
      tv: function (el, p, c) {
        var tv = $('[data-tv]', el), steps = $$('[data-tv-step]', el), photo = $('[data-tv-photo]', el), bezel = $('[data-tv-bezel]', el), fin = $('[data-tv-final]', el);
        if (!tv) return;
        var flick = c.calm ? 1 : 0.85 + Math.random() * 0.15;
        if (steps[0]) S(steps[0], 'opacity', String(win(p, 0.0, 0.26) * flick));
        if (steps[1]) S(steps[1], 'opacity', String(win(p, 0.3, 0.5) * flick));
        if (photo) S(photo, 'opacity', String(clamp((p - 0.5) / 0.08)));
        var z = ease(clamp((p - 0.56) / 0.24));
        var target = Math.max(c.vw / tv.offsetWidth, c.vh / tv.offsetHeight) * 1.12;
        S(tv, 'transform', 'scale(' + (1 + (target - 1) * z) + ')');
        if (bezel) S(bezel, 'opacity', String(1 - z));
        var a = clamp((p - 0.8) / 0.1);
        if (fin) { S(fin, 'opacity', String(a)); if (fin.firstElementChild) S(fin.firstElementChild, 'transform', 'translateY(' + ((1 - a) * 30) + 'px)'); }
      },
      /* Jacob: vandret tidslinje over ringtove */
      timeline: function (el, p, c) {
        var track = $('[data-tl-track]', el);
        if (!track) return;
        var max = Math.max(0, track.scrollWidth - c.vw);
        S(track, 'transform', 'translateX(' + (-p * max) + 'px)');
        $$('[data-rope]', el).forEach(function (r, i) { S(r, 'transform', 'scaleX(' + clamp(p * 1.05 - i * 0.03) + ')'); });
        var acc = accent();
        $$('[data-tl-item]', el).forEach(function (it, i, all) {
          var r = it.getBoundingClientRect();
          var lit = r.left < c.vw * 0.55 && r.right > c.vw * 0.2;
          var y = $('[data-tl-year]', it);
          if (!y) return;
          var col = i === all.length - 1 ? '#e23a2a' : acc;
          S(y, 'color', lit ? col : 'transparent');
          S(y, 'webkitTextStrokeColor', lit ? col : '#f2ede4');
        });
      },
      /* Alex: "Noget vildere..." flyver ind med fartstriber */
      speed: function (el, p, c) {
        var intro = $('[data-speed-intro]', el), fly = $$('[data-fly]', el), lines = $('[data-speedlines]', el);
        var out = clamp((p - 0.28) / 0.1);
        if (intro) { S(intro, 'opacity', String(1 - out)); S(intro, 'transform', 'translateX(' + (-out * 30) + 'vw)'); S(intro, 'filter', c.calm ? '' : 'blur(' + (out * 8) + 'px)'); }
        if (lines) lines.dataset.base = String(c.calm ? 0 : clamp((p - 0.25) / 0.2) * 0.8);
        fly.forEach(function (f, i) {
          var a = ease(clamp((p - 0.34 - i * 0.14) / 0.18));
          var exit = clamp((p - 0.86) / 0.14);
          var w = f.scrollWidth;
          S(f, 'transform', 'translateX(' + ((1 - a) * 120) + 'vw) translateX(' + (-exit * (w + c.vw)) + 'px) skewX(' + (c.calm ? 0 : -(1 - a) * 25 - exit * 25) + 'deg)');
          S(f, 'filter', c.calm ? '' : 'blur(' + (((1 - a) + exit) * 8) + 'px)');
        });
      },
      /* Alex: hårnålesving — path tegnes, bilen følger */
      curve: function (el, p, c) {
        var path = $('[data-curve]', el), car = $('[data-car]', el), steps = $$('[data-curve-step]', el);
        if (!path) return;
        var t = clamp(p * 1.05);
        path.setAttribute('stroke-dashoffset', String(1 - t));
        if (!path.__len) path.__len = path.getTotalLength();
        var pt = path.getPointAtLength(path.__len * t);
        var box = el.firstElementChild.getBoundingClientRect();
        if (car) S(car, 'transform', 'translate(' + (pt.x / 1000 * box.width) + 'px, ' + (pt.y / 600 * box.height) + 'px)');
        if (steps.length < 3) return;
        S(steps[0], 'opacity', String(1 - clamp((p - 0.32) / 0.06)));
        S(steps[1], 'opacity', String(win(p, 0.36, 0.64)));
        S(steps[1], 'transform', 'translateY(-50%) scale(' + (0.9 + 0.1 * clamp((p - 0.36) / 0.1)) + ')');
        S(steps[2], 'opacity', String(clamp((p - 0.66) / 0.06)));
        var narrow = c.vw < 760, edge = 'clamp(16px,3vw,48px)', w = 'min(25vw,380px)';
        [steps[0], steps[2]].forEach(function (s, i) {
          S(s, 'width', narrow ? 'auto' : w);
          S(s, 'left', narrow ? '16px' : (i === 0 ? edge : 'auto'));
          S(s, 'right', narrow ? '16px' : (i === 1 ? edge : 'auto'));
          S(s, 'background', narrow ? 'rgba(13,12,11,0.85)' : 'transparent');
          S(s, 'padding', narrow ? '12px' : '0px');
        });
      },
      /* Generiske signaturscener (Jonny, Martin, Mikkel, Oliver, Stefan, Sven, Victor) */
      scene: function (el, p, c) {
        var keep = function (s) { return s.dataset.keep || ''; };
        $$('[data-range]', el).forEach(function (s) { var r = pair(s.dataset.range), o = win(p, r[0], r[1]); S(s, 'opacity', String(o)); S(s, 'transform', keep(s) + ' translateY(' + ((1 - o) * 24) + 'px)'); });
        $$('[data-in]', el).forEach(function (s) { var o = clamp((p - +s.dataset.in) / 0.06); S(s, 'opacity', String(o)); S(s, 'transform', keep(s) + ' translateY(' + ((1 - o) * 24) + 'px)'); });
        $$('[data-draw]', el).forEach(function (s) { s.setAttribute('stroke-dashoffset', String(1 - clamp(p * (+s.dataset.draw || 1.05)))); });
        var fp = $('[data-follow]', el), dot = $('[data-dot]', el);
        if (fp && dot && dot.offsetParent) {
          var t = clamp(p * (+fp.dataset.follow || 1.05));
          var L = fp.__len || (fp.__len = fp.getTotalLength());
          var pt = fp.getPointAtLength(L * t), svg = fp.ownerSVGElement, vb = svg.viewBox.baseVal;
          var box = svg.getBoundingClientRect(), host = dot.offsetParent.getBoundingClientRect();
          S(dot, 'transform', 'translate(' + (box.left - host.left + pt.x / vb.width * box.width) + 'px, ' + (box.top - host.top + pt.y / vb.height * box.height) + 'px)');
        }
        $$('[data-at]', el).forEach(function (s) { var lit = p >= +s.dataset.at; S(s, 'opacity', lit ? '1' : '0.28'); S(s, 'transform', keep(s) + ' scale(' + (lit ? 1 : 0.86) + ')'); });
        $$('[data-split]', el).forEach(function (s) { var r = pair(s.dataset.split), q = clamp((p - r[0]) / (r[1] - r[0])); S(s, 'clipPath', 'inset(0 0 0 ' + ((1 - q) * 100) + '%)'); });
        $$('[data-split-line]', el).forEach(function (s) { var r = pair(s.dataset.splitLine), q = clamp((p - r[0]) / (r[1] - r[0])); S(s, 'left', ((1 - q) * 100) + '%'); });
        $$('[data-fall]', el).forEach(function (s) { var r = pair(s.dataset.fall), q = clamp((p - r[0]) / (r[1] - r[0])); S(s, 'transform', keep(s) + ' translateY(' + (q * q * (+s.dataset.dist || 70)) + 'vh) rotate(' + (q * q * (+s.dataset.rot || 0)) + 'deg)'); });
        $$('[data-alt]', el).forEach(function (s) { var r = pair(s.dataset.alt), q = clamp((p - r[0]) / (r[1] - r[0])); var v = ((1 - q) * (+s.dataset.from || 10)).toFixed(1).replace('.', ',') + ' m'; if (s.textContent !== v) s.textContent = v; });
        $$('[data-splash]', el).forEach(function (s) {
          var t2 = +s.dataset.splash;
          if (p >= t2 && !s.__done) { s.__done = 1; if (!c.calm) Array.prototype.forEach.call(s.children, function (r, i) { anim(r, [{ transform: 'translate(-50%,-50%) scale(0.05)', opacity: 1 }, { transform: 'translate(-50%,-50%) scale(1)', opacity: 0 }], { duration: 1200, delay: i * 150, easing: EASE }); }); }
          if (p < t2 - 0.05) s.__done = 0;
        });
        $$('[data-rotate]', el).forEach(function (s) { S(s, 'transform', 'rotate(' + (c.calm ? 0 : p * +s.dataset.rotate) + 'deg)'); });
      }
    };

    /* Højden på themets sticky header (CSS-variablen --nl-top) — sticky-scener starter under den */
    var probe = document.createElement('div');
    probe.style.cssText = 'position:absolute;visibility:hidden;pointer-events:none;width:0;height:var(--nl-top,0px)';
    root.appendChild(probe);
    var topOffset = function () { return probe.offsetHeight || 0; };

    function tick() {
      var T = topOffset();
      var vh = window.innerHeight, vw = window.innerWidth, c = { calm: calm(), vw: vw, vh: vh - T };
      /* 1: læs alle positioner */
      var jobs = [];
      q('[data-pin]').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < -vh || r.top > vh * 2) return;
        jobs.push([el, clamp((T - r.top) / Math.max(1, r.height - (vh - T)))]);
      });
      var par = [];
      if (!c.calm) q('[data-parallax]').forEach(function (el) {
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        par.push([el, (r.top + r.height / 2 - vh / 2) * parseFloat(el.dataset.parallax)]);
      });
      var wrap = q1('[data-rounds]'), bug = q1('[data-scorebug]'), wr = null, active = 0, local = 0;
      if (wrap) {
        wr = wrap.getBoundingClientRect();
        q('[data-round]').forEach(function (s2, i) { var b = s2.getBoundingClientRect(); if (b.top <= vh * 0.5) { active = i; local = clamp((vh * 0.5 - b.top) / b.height); } });
      }
      /* 2: skriv */
      jobs.forEach(function (j) { var fn = PINS[j[0].dataset.pin]; if (fn) fn(j[0], j[1], c); });
      par.forEach(function (j) { S(j[0], 'transform', 'translateY(' + j[1].toFixed(1) + 'px)'); });
      if (wrap) {
        var shown = wr.top < vh * 0.5 && wr.bottom > vh * 0.5;
        if (bug) { S(bug, 'opacity', shown ? '1' : '0'); S(bug, 'transform', shown ? 'none' : 'translateY(20px)'); S(bug, 'pointerEvents', shown ? 'auto' : 'none'); }
        if (active !== E.lapIdx) { E.lapIdx = active; E.lapStart = performance.now(); }
        E.st = { active: active, local: local, overall: clamp((vh * 0.5 - wr.top) / wr.height) };
        var set = function (sel, v) { var n = q1(sel); if (n && n.textContent !== v) n.textContent = v; };
        set('[data-hud-round]', String(active + 1));
        set('[data-hud-title]', (opts.rounds || [])[active] || '');
        q('[data-hud-fill]').forEach(function (f, i) { S(f, 'transform', 'scaleX(' + (i < active ? 1 : i === active ? local.toFixed(3) : 0) + ')'); });
      }
    }

    function live(now) {
      var vh = window.innerHeight;
      q('[data-wave]').forEach(function (w, i) {
        var r = w.ownerSVGElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var amp = Math.min(70, (+w.dataset.amp || 14) + E.v / 50), t = now / 900 + i;
        var d = 'M0 100';
        for (var x = 0; x <= 1200; x += 24) d += ' L' + x + ' ' + (100 + Math.sin(x / 120 + t) * amp * 0.7 + Math.sin(x / 53 - t * 1.3) * amp * 0.3).toFixed(1);
        w.setAttribute('d', d);
      });
      var el = Math.floor((now - E.t0) / 1000), txt = mmss(el);
      q('[data-elapsed]').forEach(function (s) { if (s.textContent !== txt) s.textContent = txt; });
      /* Alex: speedometer drevet af scroll-hastighed */
      var kmh = Math.min(320, Math.round(E.v / 12));
      var g = q1('[data-gauge]'), n = q1('[data-needle]'), sp = q1('[data-speed]');
      if (g && g.__k !== kmh) { g.__k = kmh; g.setAttribute('stroke-dashoffset', String(1 - kmh / 320)); }
      if (n) S(n, 'transform', 'rotate(' + (-90 + (kmh / 320) * 180) + 'deg)');
      if (sp && sp.textContent !== String(kmh)) sp.textContent = String(kmh);
      if (!calm()) q('[data-speedlines]').forEach(function (s) {
        var base = +(s.dataset.base || 0);
        S(s, 'opacity', String(clamp(base + kmh / 260)));
        S(s, 'transform', 'translateX(' + (-(now * (0.6 + kmh / 60)) % 400) + 'px)');
      });
      if (E.st && hud) {
        var h = hud(Object.assign({ v: E.v, ms: now - E.t0, lapMs: now - E.lapStart }, E.st));
        var tr = opts.labels || {};
        if (h.label != null && tr[h.label]) h.label = tr[h.label];
        if (h.value != null && tr[h.value]) h.value = tr[h.value];
        var lab = q1('[data-hud-label]'), val = q1('[data-hud-value]'), clk = q1('[data-hud-clock]');
        if (lab && h.label != null && lab.textContent !== h.label) lab.textContent = h.label;
        if (val && h.value != null && val.textContent !== h.value) val.textContent = h.value;
        if (clk && h.clock != null && clk.textContent !== h.clock) clk.textContent = h.clock;
      }
    }

    on(window, 'scroll', function () {
      var now = performance.now(), y = window.scrollY;
      if (E.lastT) { var dt = Math.max(16, now - E.lastT); E.v = E.v * 0.7 + (Math.abs(y - E.lastY) / dt * 1000) * 0.3; }
      if (y !== E.lastY) E.dir = y > E.lastY ? 1 : -1;
      E.lastY = y; E.lastT = now;
      if (!E.raf) E.raf = requestAnimationFrame(function () { E.raf = 0; tick(); });
    }, { passive: true });
    on(window, 'resize', function () { E.origin = null; tick(); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { if (E.alive) { E.origin = null; tick(); } });
    var frame = function (now) { if (!E.alive) return; E.v *= 0.94; live(now); requestAnimationFrame(frame); };
    requestAnimationFrame(frame);
    tick();

    /* ---------- Klik: video, "Se episoden", scorebug-links ---------- */
    E.goTo = function (id, offset) {
      var t = document.getElementById(id);
      if (t) window.scrollTo({ top: t.getBoundingClientRect().top + window.scrollY - topOffset() - (offset || 0), behavior: calm() ? 'auto' : 'smooth' });
    };
    function play(box) {
      if (!box || box.dataset.playing) return;
      var id = box.dataset.video;
      if (!id) return;
      box.dataset.playing = '1';
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0';
      f.title = box.dataset.videoTitle || 'Se episoden';
      f.allow = 'autoplay; encrypted-media; fullscreen; picture-in-picture';
      f.allowFullscreen = true;
      f.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;border:0';
      var btn = $('[data-play]', box);
      if (btn) btn.remove();
      box.appendChild(f);
    }
    on(root, 'click', function (e) {
      var t = e.target;
      var p = t.closest && t.closest('[data-play]');
      if (p) { e.preventDefault(); play(p.closest('[data-video]')); return; }
      var w = t.closest && t.closest('[data-watch]');
      if (w) { e.preventDefault(); var box = $('[data-video]'); if (box) { E.goTo(box.id || 'video', 60); play(box); } return; }
      var a = t.closest && t.closest('[data-scorebug] a[href^="#"]');
      if (a) { e.preventDefault(); E.goTo(a.getAttribute('href').slice(1)); }
    });

    E.destroy = function () {
      E.alive = false;
      E.listeners.forEach(function (l) { l[0].removeEventListener(l[1], l[2], l[3]); });
      E.timers.forEach(clearInterval);
      if (E.io) E.io.disconnect();
      E.anims.forEach(function (a) { a.cancel(); });
      grain.remove();
      probe.remove();
    };
    return E;
  }

  /* ---------- Shop the look: rigtig AJAX add-to-cart ---------- */
  function bumpCart() {
    var c = document.querySelector('#cart-icon-bubble, [data-cart-icon], a[href$="/cart"]');
    if (c && c.animate) c.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.35)' }, { transform: 'scale(1)' }], { duration: 500, easing: 'ease-out' });
  }
  function initShop(scope) {
    Array.prototype.forEach.call(scope.querySelectorAll('form[data-nl-add]'), function (form) {
      if (form.__nl) return; form.__nl = 1;
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('button[type="submit"]');
        if (!btn || btn.disabled) return;
        var fd = new FormData(form), label = btn.textContent;
        var bubble = document.getElementById('cart-icon-bubble');
        var body = { items: [{ id: +fd.get('id'), quantity: 1 }] };
        if (bubble) body.sections = 'cart-icon-bubble';
        btn.disabled = true;
        fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
        }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
          .then(function (res) {
            btn.textContent = btn.dataset.added || 'I kurven ✓';
            if (res.sections && res.sections['cart-icon-bubble'] && bubble) {
              var tmp = document.createElement('div'); tmp.innerHTML = res.sections['cart-icon-bubble'];
              var inner = tmp.querySelector('.shopify-section') || tmp; bubble.innerHTML = inner.innerHTML;
            }
            bumpCart();
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            /* Impact-themet: opdater kurv-tælleren med det samme */
            fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
              document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } }));
            }).catch(function () {});
            document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: res }));
            if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) { try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'legend-shop' }); } catch (x) {} }
            setTimeout(function () { btn.disabled = false; btn.textContent = label; }, 2400);
          })
          .catch(function (err) {
            btn.textContent = (err && err.description) ? 'Kunne ikke tilføje' : 'Prøv igen';
            setTimeout(function () { btn.disabled = false; btn.textContent = label; }, 2400);
          });
      });
      var sel = form.querySelector('select[name="id"]');
      if (sel) sel.addEventListener('change', function () {
        var opt = sel.options[sel.selectedIndex], btn = form.querySelector('button[type="submit"]'), price = form.parentElement.querySelector('[data-nl-price]');
        if (btn) { var sold = opt.hasAttribute('data-sold'); btn.disabled = sold; btn.textContent = sold ? (btn.dataset.soldout || 'Udsolgt') : (btn.dataset.label || '+ Tilføj'); }
        if (price && opt.dataset.price) price.textContent = opt.dataset.price;
      });
    });
  }


  /* ---------- "Vælg din legend": hover-intent (280 ms) ---------- */
  function initPicker(scope) {
    Array.prototype.forEach.call(scope.querySelectorAll('[data-picker]'), function (box) {
      if (box.__nl) return; box.__nl = 1;
      var rows = box.querySelectorAll('[data-pick]'), photos = box.querySelectorAll('[data-pick-photo]');
      var knock = box.querySelector('[data-pick-knock]'), tag = box.querySelector('[data-pick-tag]');
      var ep = box.querySelector('[data-pick-episode]'), tl = box.querySelector('[data-pick-tagline]'), cta = box.querySelector('[data-pick-cta]');
      var links = box.querySelectorAll('[data-pick-link]'), timer = 0, cur = 0;
      function show(i) {
        if (i === cur) return; cur = i;
        var r = rows[i], d = r.dataset;
        Array.prototype.forEach.call(rows, function (x, k) { x.classList.toggle('is-active', k === i); });
        Array.prototype.forEach.call(photos, function (p) { var on = +p.dataset.pickPhoto === i; p.classList.toggle('is-active', on); if (on) p.removeAttribute('loading'); });
        if (knock) { knock.innerHTML = ''; knock.appendChild(document.createTextNode(d.l1)); if (d.l2) { knock.appendChild(document.createElement('br')); knock.appendChild(document.createTextNode(d.l2)); } knock.style.fontSize = d.fs + 'cqw'; }
        if (tag) { tag.textContent = d.sport; tag.style.background = d.acc; tag.style.color = d.on; }
        if (ep) { ep.textContent = d.episode; ep.style.color = d.acc; }
        if (tl) tl.textContent = d.tagline;
        if (cta) { cta.textContent = d.cta; cta.style.background = d.acc; cta.style.color = d.on; }
        Array.prototype.forEach.call(links, function (a) { a.href = d.url; });
      }
      Array.prototype.forEach.call(rows, function (r, i) {
        r.addEventListener('mouseenter', function () { clearTimeout(timer); timer = setTimeout(function () { show(i); }, 280); });
        r.addEventListener('mouseleave', function () { clearTimeout(timer); });
        r.addEventListener('focus', function () { clearTimeout(timer); show(i); });
      });
    });
  }

  /* Reserve-kort uden tilknyttet produkt: find produktet på eksakt navn og læg det i kurven */
  function initFind(scope) {
    Array.prototype.forEach.call(scope.querySelectorAll('button[data-nl-find]'), function (btn) {
      if (btn.__nl) return; btn.__nl = 1;
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var root = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
        var title = btn.dataset.nlFind, label = btn.textContent, norm = function (x) { return String(x || '').trim().toLowerCase(); };
        btn.disabled = true;
        fetch(root + 'search/suggest.json?q=' + encodeURIComponent(title) + '&resources[type]=product&resources[limit]=10')
          .then(function (r) { return r.json(); })
          .then(function (j) {
            var list = (j.resources && j.resources.results && j.resources.results.products) || [];
            var hit = list.filter(function (x) { return norm(x.title) === norm(title); })[0];
            if (!hit) throw 'notfound';
            return fetch(root + 'products/' + hit.handle + '.js').then(function (r) { return r.json(); });
          })
          .then(function (prod) {
            var avail = prod.variants.filter(function (v) { return v.available; });
            if (prod.variants.length > 1 || !avail.length) { window.location.href = root + 'products/' + prod.handle; return null; }
            return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: avail[0].id, quantity: 1 }] }) })
              .then(function (r) { if (!r.ok) throw 'add'; return r.json(); });
          })
          .then(function (res) {
            if (!res) return;
            btn.textContent = btn.dataset.added || 'I kurven ✓';
            bumpCart();
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
              document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } }));
            }).catch(function () {});
            setTimeout(function () { btn.disabled = false; btn.textContent = label; }, 2400);
          })
          .catch(function () { window.location.href = btn.dataset.search; });
      });
    });
  }

  var current = null;
  function boot() {
    if (current) { current.destroy(); current = null; }
    var root = document.getElementById('MainContent') || document.getElementById('main') || document.querySelector('main') || document.body;
    var cfg = readConfig();
    var designMode = window.Shopify && window.Shopify.designMode;
    current = mount(root, { variant: cfg.variant, hud: cfg.hud, rounds: cfg.rounds || [], labels: cfg.labels || {}, calm: cfg.motion === 'calm' });
    initShop(document);
    initPicker(document);
    initFind(document);
    window.LegendEngine.current = current;
    if (designMode) document.documentElement.classList.add('nl-design-mode');
  }

  window.LegendEngine = { mount: mount, boot: boot, huds: HUDS };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', function () { setTimeout(boot, 0); });
})();
